import { render, staticRenderFns } from "./_Upload.vue?vue&type=template&id=1f0bef16"
import script from "./_Upload.vue?vue&type=script&lang=js"
export * from "./_Upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports